module.exports = __webpack_public_path__ + "img/grand-palm-room-3.f2e648a8.jpg";